import React, { useState } from "react";
import styled from "styled-components";

const formatBirthdate = (birthdate) => {
  if (!birthdate) return null;
  if (!isNaN(birthdate)) return `${birthdate} ans`;
  try {
    const parts = birthdate.split(/[/-]/);
    if (parts.length >= 2) {
      const day = parts[0];
      const monthIndex = parseInt(parts[1], 10) - 1;
      const monthName = new Date(0, monthIndex).toLocaleString("fr-FR", { month: "long" });
      return `${day} ${monthName}`;
    }
    return null;
  } catch (e) {
    return null;
  }
};

const Portfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [altImage, setAltImage] = useState("");

  const openImage = (url, alt) => {
    setSelectedImage(url);
    setAltImage(alt);
  };

  const closeImage = () => {
    setSelectedImage(null);
    setAltImage("");
  };

  const members = [
    {
      name: "Sabine",
      birthdate: "",
      reason: "Le théâtre est un rêve d'enfance, et, de plus, cela fait travailler la mémoire.",
      message: "Jouer au profit d'associations, c'est un joli objectif.",
      imageUrl: "/album/portfolio/Sabine.jpeg",
    },
       {
      name: "Sandrine",
      birthdate: "12/07",
      reason: " Déjà engagée dans le chant et le conte, je souhaitais explorer ma voix autrement et apprendre à incarner des personnages. J’ai découvert la troupe grâce à une amie qui avait vu la pièce de l’an dernier. J’ai été séduite par l’ambiance à la fois sérieuse et conviviale, ainsi que par la proximité des répétitions.",
      message: "Si vous souhaitez explorer une autre facette de votre créativité tout en vous amusant, osez vous lancer. Peu importe votre âge ou votre genre, le théâtre est une expérience ouverte à toutes et tous.",
      imageUrl: "/album/portfolio/Sandrine2.jpg",
    },
    {
      name: "Clément",
      birthdate: "19/11",
      reason: "J'ai rejoint la troupe car j'avais besoin de gagner en confiance. J'ai donc cherché du théâtre non loin de chez moi à Neuville-en-Ferrain. J'y ai trouvé une famille.",
      message: "Bienvenue à tous les nouveaux membres ! Nous sommes une famille et nous sommes impatients de créer de beaux souvenirs ensemble. N'ayez pas peur de franchir le pas.",
      imageUrl: "/album/portfolio/clement.JPG",
    },
    {
      name: "Marie",
      birthdate: "",
      reason: "Il y a plusieurs années, j'ai découvert, par hasard, l'existence d'une troupe de théâtre à Neuville-en-Ferrain. Je suis allée me présenter et j'ai été adoptée.",
      message: "Tout d'abord, n'hésitez pas à venir voir nos pièces parce qu'on s'amuse beaucoup. Si quelques hommes ont envie de nous rejoindre, qu'ils n'hésitent pas !",
      imageUrl: "/album/portfolio/Marie.jpg",
    },
    {
      name: "Dominique",
      birthdate: "16/02",
      reason: "J'y suis depuis sa création en 2008. J'ai repris les rênes en 2014. J'étais d'un tempérament timide et ça m'a beaucoup aidé. J'ai vécu des moments inoubliables. J'ai rencontré des personnes formidables avec des comédiens qui sont passés par les Z'Ineuvitables, avec un réel plaisir de monter sur scène. Aujourd'hui la troupe continue toujours sa route.",
      message: "Si des membres intègrent la troupe, il faut de la rigueur, un bon vouloir et une envie certaine d'apprendre à se surpasser.",
      imageUrl: "/album/portfolio/Dominique.jpeg",
    },
    {
      name: "Élisa",
      birthdate: "18/04",
      reason: "Je me suis lancée dans le théâtre il y a quelques mois ! Je voulais améliorer mes compétences en jouant, et j’ai découvert cette troupe dans ma ville. J’ai fait une séance d’essai et j’ai tout de suite décidé de continuer !:)",
      message: "L’ambiance est super, c’est comme une famille !",
      imageUrl: "/album/portfolio/Elisa.jpg",
    },
    {
      name: "Élodie",
      birthdate: "26/07/1988",
      reason: "Pour sortir de ma zone de confort, prendre davantage confiance en moi et apprendre à être plus à l’aise à l’oral. Étant plutôt réservée, je sais que le théâtre m’aidera dans ma vie professionnelle. Et surtout… pour passer de bons moments et m’amuser !",
      message: "Petit à petit, on devient une vraie famille, on partage, on rigole, on se dépasse et surtout on passe de super moments ensemble. Alors si vous hésitez encore, lancez-vous… vous ne le regretterez pas ! 😊",
      imageUrl: "/album/portfolio/Elodie.jpg",
    },
    {
      name: "Corinne",
      birthdate: "",
      reason: "",
      message: "",
      imageUrl: "/album/portfolio/anonyme.png",
    },
    {
      name: "Arnold",
      birthdate: "",
      reason: "",
      message: "",
      imageUrl: "/album/portfolio/anonyme.png",
    },
    {
      name: "Helene",
      birthdate: "",
      reason: "",
      message: "",
      imageUrl: "/album/portfolio/anonyme.png",
    },
    {
      name: "Marlène",
      birthdate: "",
      reason: "",
      message: "",
      imageUrl: "/album/portfolio/anonyme.png",
    },
  ];

  // Tri alphabétique des membres par leur prénom
  const sortedMembers = [...members].sort((a, b) =>
    a.name.localeCompare(b.name, "fr", { sensitivity: "base" })
  );

  return (
    <PortfolioContainer>
      <h1>👋 Bienvenue chez les Z'Ineuvitables</h1>
      <MembersGrid>
        {sortedMembers.map((member, index) => (
          <MemberCard key={index}>
            <MemberImage
              src={member.imageUrl}
              alt={`Portrait de ${member.name}`}
              onClick={() => openImage(member.imageUrl, `Portrait de ${member.name}`)}
            />
            <CardContent>
              <h2>{member.name}</h2>
              {member.birthdate && (
                <p>🎂 {formatBirthdate(member.birthdate)}</p>
              )}
              <p>
                <strong>Pourquoi j'ai rejoint :</strong>{" "}
                {member.reason || "Information non disponible."}
              </p>
              <p>
                <strong>Message :</strong>{" "}
                {member.message || "Pas de message pour le moment."}
              </p>
            </CardContent>
          </MemberCard>
        ))}
      </MembersGrid>
      {selectedImage && (
        <LightboxOverlay onClick={closeImage}>
          <LightboxContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={closeImage}>×</CloseButton>
            <LightboxImage src={selectedImage} alt={altImage} />
          </LightboxContent>
        </LightboxOverlay>
      )}
    </PortfolioContainer>
  );
};

export default Portfolio;

// Styled-components
const PortfolioContainer = styled.div`
  padding: 150px 40px 40px;
  text-align: center;
  h1 {
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: #007bff;
  }
  @media (max-width: 768px) {
    padding: 110px 20px 20px;
  }
`;

const MembersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const MemberCard = styled.div`
  background: #ffffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  }
`;

const MemberImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  cursor: pointer;
  display: block;
  margin: 0 auto;
`;

const CardContent = styled.div`
  padding: 20px;
  text-align: left;
  h2 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 10px;
  }
  p {
    font-size: 0.9rem;
    color: #555;
    line-height: 1.4;
    margin-bottom: 10px;
  }
`;

const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow-y: auto;
`;

const LightboxContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
`;

const LightboxImage = styled.img`
  max-width: 90vw;
  max-height: 85vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 1.8rem;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  &:hover {
    background: rgba(0, 0, 0, 0.9);
  }
`;